export const emptyBasicInfoForm = {
  jobTitle: '',
  jobDescription: '',
  providerCategory: { label: '', value: 0 },
  aoiSpecialty: { label: '', value: '' },
  subspecialties: [] as { label: string; value: string }[],
  generalSpecialtyFlag: true,
  workLocation: { label: 'Remote', value: 'REMOTE' },
  jobType: { label: '', value: '' },
  employmentClassification: { label: '', value: '' },
};

export const JOB_TYPE_OPTIONS = [
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Part-time', value: 'Part Time' },
  { label: 'Locums Tenens', value: 'Locums Tenens' },
];

export const EMPLOYMENT_CLASSIFICATION_OPTIONS = [
  { label: 'Full Time', value: 'Full Time' },
  { label: 'Part Time', value: 'Part Time' },
  { label: 'Contract', value: 'Contract' },
];

export const WORK_LOCATION_OPTIONS = [
  { label: 'Onsite', value: 'ONSITE' },
  { label: 'Partial Remote', value: 'PARTIAL_REMOTE' },
  { label: 'Remote', value: 'REMOTE' },
];
